import { createContext, useContext } from 'react'
import { type ZodType } from 'zod'

type SchemaType = ZodType | null

const ValidationSchemaContext = createContext<SchemaType>(null)

export const ValidationSchemaProvider = ValidationSchemaContext.Provider

export const useValidationSchema = () => useContext(ValidationSchemaContext)
